import auth from './authentication'

const api = {
  auth
}

export default api
